/**
* LanguageContextManager.js
* 
* Created on 14-mei-2014, 13:37:41
*
* @author Ivo Swartjes for Ranj
**/

import KeyMomentChoiceContent from "/lib/html5-software-library/src/ranj/eng/content/KeyMomentChoiceContent";
import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";
import NGTDialogPlayerEvent from "../../../dialog/NGTDialogPlayerEvent";
import LanguageContextHelper from "./LanguageContextHelper";
import LanguageContextTypes from "./LanguageContextTypes";
import RevisableText from "./RevisableText";

export default class LanguageContextManager {
    constructor(revisionToolGateway, dispatcher, languagePack, languagePackRegistry) {
        this._eventDispatcher = dispatcher;
        this._languagePack = languagePack;
        this._languagePackRegistry = languagePackRegistry;
        this._revisionToolGateway = revisionToolGateway;

        this._languageContext = [];

        this._handleDialogContentBound = this._handleDialogContent.bind(this);
        this._handleDialogOptionBound = this._handleDialogOption.bind(this);
        this._handleDialogOptionChosenBound = this._handleDialogOptionChosen.bind(this);

        this._addEventListeners();
    }

    destroy() {
        this._removeEventListeners();
        this._languageContext = null;

        this._handleDialogContentBound = null;
        this._handleDialogOptionBound = null;
        this._handleDialogOptionChosenBound = null;
    }

    getLPLabelsInContext() {
        return this._languageContext;
    }

    _addEventListeners() {
        this._eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_CONTENT, this._handleDialogContentBound);
        this._eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_OPTION, this._handleDialogOptionBound);
        this._eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_OPTION_CHOSEN, this._handleDialogOptionChosenBound);
    }

    _removeEventListeners() {
        this._eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_CONTENT, this._handleDialogContentBound);
        this._eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_OPTION, this._handleDialogOptionBound);
        this._eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_OPTION_CHOSEN, this._handleDialogOptionChosenBound);
    }

    _handleDialogContent({ params }) {
        if (isNull(params.data) || isNull(params.data.data.content)) return;

        this._addContentToContext(params.data.data.content, LanguageContextTypes.TYPE_NPC_TEXT);
    }

    _handleDialogOption({ params }) {
        if (isNull(params.data) || isNull(params.data.data.content)) return;

        const content = params.data.data.content;

        if (content.type === KeyMomentChoiceContent.TYPE) {
            this._addContentToContext(content, LanguageContextTypes.TYPE_DECISION_OPTION);
        } else {
            this._addContentToContext(content, LanguageContextTypes.TYPE_DIALOG_OPTION);
        }
    }

    _handleDialogOptionChosen(event) {
        this._clearContext();
    }

    _addContentToContext(content, type) {
        const lpLabels = LanguageContextHelper.getRevisableLPLabelsForContent(this._languagePack, content);

        // TODO: this assumes only one type of language property per content.
        if (lpLabels.length > 0) {
            for (let i = 0; i < lpLabels.length; i++) {
                const curText = this._languagePack.getText(lpLabels[i]);
                if (!isNull(curText) && curText.length > 0) {
                    this._addToContext(lpLabels[i], type);
                }
            }
        }
    }

    _addToContext(lpLabel, type) {
        this._languageContext.push(lpLabel);

        const lpAsset = this._languagePackRegistry.getAssetURLForLanguagePackID(lpLabel);

        this._revisionToolGateway.addRevisableText(new RevisableText(lpAsset, lpLabel, type, this._languagePack.getText(lpLabel)));
    }

    _getContext() {
        return this._languageContext;
    }

    _clearContext() {
        this._languageContext.splice(0);

        this._revisionToolGateway.clearRevisableTexts();
    }
}
